// PowerSync — реактивные хуки для конспектов (notes).
//
// LocalNote — РЕАЛЬНЫЕ колонки БД (schema.ts / information_schema).
// `generation_status` (не `status`); TipTap JSON в `content` как TEXT-строка.
import { usePowerSyncQuery } from "@/lib/powersync/use-query";

export interface LocalNote {
	id: string;
	user_id: string;
	material_id: string | null;
	source_material_id: string | null;
	/** Тема курса-источник (миграция 0083): конспект собран из материалов темы. */
	source_subsection_id: string | null;
	title: string;
	content: string | null;
	plain_text: string | null;
	detail_level: string | null;
	locale: string | null;
	applied_disclaimer: number;
	version: number;
	ai_model: string | null;
	prompt_version: string | null;
	generation_trace_id: string | null;
	generation_status: string | null;
	generation_error_message: string | null;
	created_at: string;
	updated_at: string;
	deleted_at: string | null;
	/** LEFT JOIN materials.name (список). */
	material_name?: string | null;
	/** LEFT JOIN materials.source_kind (список). */
	material_source_kind?: string | null;
}

export function useNotesQuery(userId: string | undefined) {
	return usePowerSyncQuery<LocalNote>(
		`SELECT n.*, m.name AS material_name, m.source_kind AS material_source_kind
		   FROM notes n
		   LEFT JOIN materials m ON m.id = COALESCE(n.material_id, n.source_material_id)
		  WHERE n.user_id = ? AND n.deleted_at IS NULL
		ORDER BY n.updated_at DESC`,
		[userId ?? ""],
	);
}

export function useNotesByMaterialQuery(materialId: string | undefined) {
	return usePowerSyncQuery<LocalNote>(
		`SELECT * FROM notes
		   WHERE material_id = ? AND deleted_at IS NULL
		ORDER BY updated_at DESC`,
		[materialId ?? ""],
	);
}

export function useNoteByIdQuery(id: string | undefined) {
	return usePowerSyncQuery<LocalNote>(`SELECT * FROM notes WHERE id = ? AND deleted_at IS NULL`, [
		id ?? "",
	]);
}
